import { render, staticRenderFns } from "./UgiInlineAlert.vue?vue&type=template&id=31cb4704&"
import script from "./UgiInlineAlert.vue?vue&type=script&lang=js&"
export * from "./UgiInlineAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports